export function toEuro(price?: number) {
  if (!price) {
    return
  }

  return new Intl.NumberFormat('sk-SK', {
    style: 'currency',
    currency: 'EUR',
  }).format(price)
}
